/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChangeType } from './ChangeType';
import {
    ChangeTypeFromJSON,
    ChangeTypeFromJSONTyped,
    ChangeTypeToJSON,
    ChangeTypeToJSONTyped,
} from './ChangeType';
import type { ChangeAdditionalData } from './ChangeAdditionalData';
import {
    ChangeAdditionalDataFromJSON,
    ChangeAdditionalDataFromJSONTyped,
    ChangeAdditionalDataToJSON,
    ChangeAdditionalDataToJSONTyped,
} from './ChangeAdditionalData';
import type { ProductType } from './ProductType';
import {
    ProductTypeFromJSON,
    ProductTypeFromJSONTyped,
    ProductTypeToJSON,
    ProductTypeToJSONTyped,
} from './ProductType';
import type { RequirementStatus } from './RequirementStatus';
import {
    RequirementStatusFromJSON,
    RequirementStatusFromJSONTyped,
    RequirementStatusToJSON,
    RequirementStatusToJSONTyped,
} from './RequirementStatus';
import type { ChangeScope } from './ChangeScope';
import {
    ChangeScopeFromJSON,
    ChangeScopeFromJSONTyped,
    ChangeScopeToJSON,
    ChangeScopeToJSONTyped,
} from './ChangeScope';

/**
 * 
 * @export
 * @interface GetChangesResponse
 */
export interface GetChangesResponse {
    /**
     * 
     * @type {ChangeScope}
     * @memberof GetChangesResponse
     */
    changeScope: ChangeScope;
    /**
     * 
     * @type {ProductType}
     * @memberof GetChangesResponse
     */
    productType: ProductType;
    /**
     * 
     * @type {string}
     * @memberof GetChangesResponse
     */
    productId: string;
    /**
     * 
     * @type {ChangeType}
     * @memberof GetChangesResponse
     */
    changeType: ChangeType;
    /**
     * 
     * @type {RequirementStatus}
     * @memberof GetChangesResponse
     */
    status: RequirementStatus;
    /**
     * 
     * @type {Date}
     * @memberof GetChangesResponse
     */
    createdDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetChangesResponse
     */
    resolvedDate?: Date | null;
    /**
     * 
     * @type {ChangeAdditionalData}
     * @memberof GetChangesResponse
     */
    additionalData?: ChangeAdditionalData;
}



/**
 * Check if a given object implements the GetChangesResponse interface.
 */
export function instanceOfGetChangesResponse(value: object): value is GetChangesResponse {
    if (!('changeScope' in value) || value['changeScope'] === undefined) return false;
    if (!('productType' in value) || value['productType'] === undefined) return false;
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('changeType' in value) || value['changeType'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdDate' in value) || value['createdDate'] === undefined) return false;
    return true;
}

export function GetChangesResponseFromJSON(json: any): GetChangesResponse {
    return GetChangesResponseFromJSONTyped(json, false);
}

export function GetChangesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChangesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'changeScope': ChangeScopeFromJSON(json['changeScope']),
        'productType': ProductTypeFromJSON(json['productType']),
        'productId': json['productId'],
        'changeType': ChangeTypeFromJSON(json['changeType']),
        'status': RequirementStatusFromJSON(json['status']),
        'createdDate': (new Date(json['createdDate'])),
        'resolvedDate': json['resolvedDate'] == null ? undefined : (new Date(json['resolvedDate'])),
        'additionalData': json['additionalData'] == null ? undefined : ChangeAdditionalDataFromJSON(json['additionalData']),
    };
}

export function GetChangesResponseToJSON(json: any): GetChangesResponse {
    return GetChangesResponseToJSONTyped(json, false);
}

export function GetChangesResponseToJSONTyped(value?: GetChangesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'changeScope': ChangeScopeToJSON(value['changeScope']),
        'productType': ProductTypeToJSON(value['productType']),
        'productId': value['productId'],
        'changeType': ChangeTypeToJSON(value['changeType']),
        'status': RequirementStatusToJSON(value['status']),
        'createdDate': ((value['createdDate']).toISOString()),
        'resolvedDate': value['resolvedDate'] === null ? null : ((value['resolvedDate'] as any)?.toISOString()),
        'additionalData': ChangeAdditionalDataToJSON(value['additionalData']),
    };
}

